"use client";

/**
 * WP6: "browser-print IS de PDF-route, geen library" (bouwplan). A tiny
 * client island so the rest of /zakelijk/overzicht/page.js can stay a plain
 * server component (no data fetch, no interactivity needed anywhere else on
 * the page) -- only this one button needs `window.print()`.
 *
 * `print:hidden` (Tailwind's built-in print variant, confirmed present in
 * this repo's Tailwind v4 build) hides it from the printed/PDF output
 * itself: a button that does nothing on paper has no business appearing on
 * the page a director actually reads.
 */
export default function PrintButton() {
  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="print:hidden inline-flex items-center justify-center gap-2 rounded-lg bg-[#FF7B00] px-5 py-2.5 text-[14.5px] font-semibold text-white shadow-sm transition hover:bg-[#FF5500]"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4" aria-hidden="true">
        <polyline points="6 9 6 2 18 2 18 9" />
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <rect x="6" y="14" width="12" height="8" />
      </svg>
      Print of bewaar als PDF
    </button>
  );
}
